export function createInjectionKey(key) {
  return key;
}